import customClassName from "@configuratorware/configurator-frontendgui/App/Utils/customClassName";
import Api from "@configuratorware/configurator-frontendgui/Framework/Api";
import { t } from "@configuratorware/configurator-frontendgui/Framework/i18n";
import MainButton from "@configuratorware/configurator-frontendgui/Shared/Components/MainButton";
import {
  Box,
  CircularProgress,
  IconButton,
  makeStyles,
} from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog/Dialog";
import DialogContent from "@material-ui/core/DialogContent/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle/DialogTitle";
import Icon from "@material-ui/core/Icon/Icon";
import RootRef from "@material-ui/core/RootRef/RootRef";
import Typography from "@material-ui/core/Typography/Typography";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import { PANTS_CATEGORIES } from "../CustomHeader/CustomHeader";

function NextArrow(props) {
  const { onClick } = props;
  return (
    <IconButton
      aria-label="next item"
      onClick={onClick}
      style={{
        position: "absolute",
        right: -60,
        top: "50%",
        marginTop: -24,
      }}
    >
      <ChevronRightIcon />
    </IconButton>
  );
}

function PrevArrow(props) {
  const { onClick } = props;
  return (
    <IconButton
      aria-label="previous item"
      onClick={onClick}
      style={{
        position: "absolute",
        left: -60,
        top: "50%",
        marginTop: -24,
      }}
    >
      <ChevronLeftIcon />
    </IconButton>
  );
}

const settings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />,
};

export const useStyles = makeStyles(
  (theme) => ({
    slideWrapper: {
      width: 500,
      margin: "0 auto",
      [theme.breakpoints.down("xs")]: {
        width: "100%",
      },
    },
    contentPositioning: {
      paddingLeft: 0,
      paddingRight: 0,
      [theme.breakpoints.down("xs")]: {
        paddingLeft: 0,
        paddingRight: 8,
        marginRight: "-8px",
      },

      "& .slick-slide": {
        "& img": {
          width: "auto",
          height: 300,
          objectFit: "cover !important",
          [theme.breakpoints.down("xs")]: {
            width: "100%",
            height: "auto",
          },
        },
      },

      "& p": {
        fontSize: 15,
        letterSpacing: "normal",
      },
      marginRight: 4,
      padding: 0,
    },
    dialogWrapper: {
      borderTop: "7px solid " + theme.palette.primary.main,
      padding: 0,
      overflow: "hidden",
      [theme.breakpoints.down("xs")]: {
        padding: "0px",
      },
      "& hr": {
        height: 0,
      },
    },

    closeIcon: {
      position: "absolute",
      right: 32,
      top: 32,
      [theme.breakpoints.down("xs")]: {
        right: 16,
      },
      "&:hover": {
        cursor: "pointer",
      },
    },
    dialogTitleRoot: {
      padding: "20px 0",
    },
    mainButton: {
      margin: "8px  0px 0px",
      padding: "6px 15px",
      height: 40,
      lineHeight: 1.5,
      [theme.breakpoints.down("xs")]: {
        height: 56,
      },
    },
    mainButtonLabel: {
      [theme.breakpoints.down("xs")]: {
        whiteSpace: "normal",
        fontSize: 12,
      },
    },
  }),
  { name: "Outfit" }
);

const Slide = ({ item, type }) => {
  return (
    <div key={item.id}>
      {type === "jackets" && (
        <Typography variant="body1" align="center">
          {item.configuration.item.title}
        </Typography>
      )}
      <img
        src={item.configuration.images[0]}
        alt={item.configuration.item.title}
        style={{ width: "100%", objectFit: "cover" }}
      />
      {type === "pants" && (
        <Typography variant="body1" align="center">
          {item.configuration.item.title}
        </Typography>
      )}
    </div>
  );
};

const ActiveItem = ({ image, title, type }) => (
  <Slide
    type={type}
    item={{
      configuration: {
        images: [image],
        item: {
          title,
        },
      },
    }}
  />
);

const Outfit = ({
  isOutfitOpen,
  isSmallScreen,
  onClose,
  DialogActionsWrapper,
  activeItemImage,
}) => {
  const classes = useStyles();
  const dialogContentRef = useRef<HTMLDivElement>(null);
  // @ts-ignore
  const categories = useSelector((state) => state.products.categories);
  // @ts-ignore
  const { item } = useSelector((state) => state.configurator.configuration);
  // @ts-ignore
  const basketItems = useSelector((state) => state.basket.items);

  const [jackets, setJackets] = useState(null);
  const [pants, setPants] = useState(null);
  const [selectedSlideItem, setSelectedSlideItem] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const [activeItemType, setActiveItemType] = useState<
    "jacket" | "pants" | null
  >(null);

  useEffect(() => {
    const activeItemId = item.identifier;

    categories.forEach((category) => {
      const cat = PANTS_CATEGORIES.includes(category.category)
        ? "pants"
        : "jacket";

      category.items.forEach((item) => {
        if (item.identifier === activeItemId) {
          setActiveItemType(cat);
        } else if (item.subCategories) {
          item.subCategories.forEach((subCat) => {
            if (subCat.identifier === activeItemId) {
              setActiveItemType(cat);
            }
          });
        }
      });
    });
  }, [item]);

  useEffect(() => {
    if (basketItems.length > 0) {
      const jItems = basketItems.filter(
        (item) =>
          item.configuration.item.title.toLowerCase().includes("jacket") ||
          item.configuration.item.title.toLowerCase().includes("jacken")
      );
      if (jItems) {
        setJackets(jItems);
      }

      const pItems = basketItems.filter(
        (item) =>
          item.configuration.item.title.toLowerCase().includes("pant") ||
          item.configuration.item.title.toLowerCase().includes("hosen")
      );

      if (pItems) {
        setPants(pItems);
      }
    }
  }, [basketItems, item]);

  const handleTouchMove = (evt) => {
    const dialogContent = dialogContentRef.current;
    evt.preventDefault();
    dialogContent.scrollTo(0, dialogContent.scrollTop);
  };

  const onPrintClicked = async () => {
    let selectedItem = selectedSlideItem;
    const activeItemIsJacket = activeItemType === "jacket";

    if (!selectedSlideItem) {
      selectedItem = activeItemIsJacket ? pants[0] : jackets[0];
    }

    setIsLoading(true);

    const data = {
      configuration: selectedItem.configuration.code,
      generatedImage: activeItemImage,
      itemIdentifier: item.identifier,
    };

    Api.request({
      url: "requestlist/preview",
      method: "post",
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
      },
      data,
    })
      .then(({ data: blob }) => {
        const newBlob = new Blob([blob], { type: "application/pdf" });
        // @ts-ignore
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          // @ts-ignore
          window.navigator.msSaveOrOpenBlob(newBlob);
          return;
        }
        const data = window.URL.createObjectURL(newBlob);

        window.open(data, "_blank");
        setIsLoading(false);
      })
      .catch((e) => {
        setIsLoading(false);
      });
  };

  const renderJackets = () => {
    return (
      <Box className={classes.slideWrapper}>
        {activeItemType === "jacket" ? (
          <ActiveItem
            image={activeItemImage}
            title={item.title}
            type="jackets"
          />
        ) : (
          <>
            {jackets && (
              <Slider
                {...settings}
                id="jackets"
                afterChange={(idx) => {
                  setSelectedSlideItem(jackets[idx]);
                }}
              >
                {jackets.map((jacket) => (
                  <Slide item={jacket} type="jackets" />
                ))}
              </Slider>
            )}
          </>
        )}
      </Box>
    );
  };

  const renderPants = () => {
    return (
      <Box className={classes.slideWrapper}>
        {activeItemType === "pants" ? (
          <ActiveItem image={activeItemImage} title={item.title} type="pants" />
        ) : (
          <>
            {pants && (
              <Slider
                {...settings}
                id="pants"
                afterChange={(idx) => {
                  setSelectedSlideItem(pants[idx]);
                }}
              >
                {pants.map((pant) => (
                  <Slide item={pant} type="pants" />
                ))}
              </Slider>
            )}
          </>
        )}
      </Box>
    );
  };

  return (
    <>
      {isLoading && (
        <Box
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            zIndex: 2000,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            background: "rgba(255,255,255,0.3)",
          }}
        >
          <CircularProgress />
        </Box>
      )}

      <Dialog
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        classes={{
          paper: classes.dialogWrapper,
        }}
        onClose={onClose}
        open={isOutfitOpen}
        maxWidth={"md"}
        fullWidth
        fullScreen={isSmallScreen}
        scroll="paper"
      >
        <DialogTitle classes={{ root: classes.dialogTitleRoot }}>
          <Typography variant="body1">
            <b>{t("outfit.title")}</b>
          </Typography>
          <Icon className={classes.closeIcon} onClick={onClose}>
            close
          </Icon>
        </DialogTitle>
        <RootRef rootRef={dialogContentRef}>
          <DialogContent classes={{ root: classes.contentPositioning }}>
            {renderJackets()}
            {renderPants()}

            <Box mt={5} display="flex" justifyContent="flex-end">
              <MainButton
                className={customClassName("cta-button")}
                variant="contained"
                size="medium"
                fullWidth
                onClick={() => {
                  onPrintClicked();
                }}
                classes={{
                  root: classes.mainButton,
                  label: classes.mainButtonLabel,
                }}
              >
                {t("outfit.print")}
              </MainButton>
            </Box>
          </DialogContent>
        </RootRef>
        <DialogActionsWrapper
          onTouchMove={handleTouchMove}
        ></DialogActionsWrapper>
      </Dialog>
    </>
  );
};

export default Outfit;
